var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__v-oembed"},[(!_vm.resJson.provider_name && !_vm.errorMessage)?_c('div',{staticClass:"__v-oembed-loading",style:(_vm.boxStyle)},[_vm._v("Loading....")]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"__v-oembed-error",style:(_vm.boxStyle)},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669f0806","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oembed/oembed.vue
// module id = 1037
// module chunks = 0